// FilterContext.js
import React, { createContext, useState, useContext } from 'react';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    category: [],
    intent: [],
    initiationMethod: null,
    queue: null,
    agent: null,
    callId: '',
    excludeWeekends: true,
    dateRange: { value: 'today', label: 'Today' },
    dateStart: null,
    dateEnd: null,
    minorIntents: [],
  });

  return (
    <FilterContext.Provider value={{ filters, setFilters }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => useContext(FilterContext);